import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MenuLayout from "@/lib/components/layout/menu/MenuLayout.vue";


export default /*#__PURE__*/_defineComponent({
  name: 'LeftMenu',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MenuLayout, {
    headerText: 'Mammal annotator',
    footerText: 'Copyright © 2023 Webfarmer',
    onOpenHelp: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open_help')))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})